import { Component } from '@angular/core';
import { ButtonModule, ButtonOptions } from '@usitsdasdesign/dds-ng/button';
import { ExtThemes, ButtonKind, Size, WidthState } from '@usitsdasdesign/dds-ng/shared';

@Component({
  selector: 'app-project-team',
  standalone: true,
  imports: [
    ButtonModule,
  ],
  templateUrl: './project-team.component.html',
  styleUrl: './project-team.component.scss'
})
export class ProjectTeamComponent {
  buttonOptions: ButtonOptions = {
    theme: ExtThemes.green,
    kind: ButtonKind.primaryLoud,
    size: Size.lg,
    width: WidthState.fixed,
    isLoading: false,
    icon: 'dds-icon_user',
    isIconLeft: true,
    isColorBg: false,
    isInverse: false,
    disabled: false,
    ariaLabel: 'Person',
    customClass: '',
    role: 'button'
  }

  buttonClick(): void {
  }
}
